import ExamStatisticApi from '@/apis/business/teacher/exam-statistic-api'

export default {
  namespaced: true,

  state: {
    examStatistic: [],
    noteExamStatistic: '',
    classRoomsStatitic: []

  },

  getters: {},

  mutations: {

    setClassroomsExam (state, classroomsByGrade) {
      state.classRoomsStatitic = classroomsByGrade
    },
    /**
     * @description cập nhật giá trị thống kê kết quả
     * @author lhlong
     */
    setExamStatistic (state, data) {
      state.examStatistic = data
    },

    /**
     * set giá trị của ExamStatistic
     * @param {*} state
     * @param {*} noteExamStatistic
     */
    setNoteExamStatistic (state, noteExamStatistic) {
      if (!noteExamStatistic) {
        state.noteExamStatistic = ''
      } else {
        state.noteExamStatistic = noteExamStatistic
      }
    }
  },

  actions: {
    /**
     * @description Gọi API để lấy thống kê kết quả
     * @author lhlong
     */
    getExamStatistic (context, param) {
      return new Promise((resolve, reject) => {
        ExamStatisticApi.getAsync(`/detail-id/${param}`)
          .then((res) => {
            context.commit('setExamStatistic', res.Data)

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API để lấy thống kê kết quả
     * @author lhlong
     */
    recreateExamStatistic (context, params) {
      return new Promise((resolve, reject) => {
        ExamStatisticApi.getAsync('/re-create', { params })
          .then((res) => {
            context.commit('setExamStatistic', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật ghi chú cho Examstatistic
     * @param {*} context
     * @param {*} params
     * @returns
     * CreateBy:NVDuc 14.10
     */
    updateNoteExamSatistic (context, params) {
      return new Promise((resolve, reject) => {
        ExamStatisticApi.postAsync('/note', params)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy giá trị examStatistic theo lớp
     * @param {*} context
     * @param {*} params
     * @returns
     * CreateBy: NVDuc 14.10
     */
    getNoteExamStatisticByFilter (context, params) {
      return new Promise((resolve, reject) => {
        ExamStatisticApi.getAsync('/classCode', { params })
          .then((res) => {
            context.commit('setNoteExamStatistic', res.Data)

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
